import React from 'react';
import Seo from '../components/Seo';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../i18n/translations';
import '../styles/CredentialsPage.css';

const CredentialsPage: React.FC = () => {
  const { language } = useLanguage();
  const c = translations[language].about.credentials;

  return (
    <div className="credentials-page">
      <Seo title={`${c.title} | الشراع`} description={c.intro} path="/credentials" />
      <section className="credentials-hero">
        <div className="container">
          <h1>{c.title}</h1>
          <p>{c.intro}</p>
        </div>
      </section>

      <section className="credentials-body">
        <div className="container credentials-grid">
          <div className="credentials-details">
            <p className="credentials-legal-name">
              <span>{c.legalNameLabel}</span>
              <strong>{c.legalName}</strong>
            </p>
            <dl className="credentials-list">
              {c.fields.map((field) => (
                <div key={field.label} className="credentials-row">
                  <dt>{field.label}</dt>
                  <dd>{field.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <figure className="credentials-certificate">
            <a
              href="/commercial-registration.jpg"
              target="_blank"
              rel="noopener noreferrer"
              title={c.openCertificate}
            >
              <img src="/commercial-registration.jpg" alt={c.certificateCaption} loading="lazy" />
            </a>
            <figcaption>{c.certificateCaption}</figcaption>
          </figure>
        </div>
      </section>
    </div>
  );
};

export default CredentialsPage;
